import {
  filterGeoBlockedItems,
  shouldExcludeByGeoLocation,
} from '../../utils/shouldExcludeByGeoLocation'

// import CasinoWorker from './casino.worker'

// const casinoWorker = typeof window === 'object' && new CasinoWorker()

// export default casinoWorker

function filterCasinoData(casinoApi, type) {
  return (
    casinoApi?.find((casinoDataGroup) =>
      casinoDataGroup?.casinoData?.some(
        (row) => row?.lobby_type == type?.replaceAll('-', '_')
      )
    )?.casinoData || []
  )
}

function filterCasinoGamesProviders(casinoData, accessCountry, isLoggedIn) {
  casinoData.forEach((layout) => {
    if (layout?.acf_fc_layout === 'games_row') {
      layout.game_category[0].carousel_games = filterGeoBlockedItems(
        layout?.game_category?.[0]?.carousel_games,
        accessCountry,
        isLoggedIn
      )
    } else if (layout?.acf_fc_layout === 'game_providers') {
      layout.providers = filterGeoBlockedItems(
        layout?.providers,
        accessCountry,
        isLoggedIn
      )
    }
  })
  return casinoData
}

function filterSearchModalGames(casinoData, accessCountry, isLoggedIn) {
  const searchModal = casinoData?.find((e) =>
    e?.search_modal_category_setup?.game_category?.[0]?.carousel_games?.some(
      (game) => game?.slug
    )
  )

  if (!searchModal) return searchModal
  searchModal.search_modal_category_setup.game_category[0].carousel_games =
    filterGeoBlockedItems(
      searchModal?.search_modal_category_setup?.game_category?.[0]
        ?.carousel_games,
      accessCountry,
      isLoggedIn
    )

  return searchModal
}

function filterHorizontalMenu(casinoData) {
  return casinoData?.find((e) => e?.menu_items?.some((item) => item?.type))
}

function filterCategories(casinoMenu, type) {
  return (
    casinoMenu?.filter(
      (row) => row.is_visible && row.type === type?.replaceAll('-', '')
    ) || []
  )
}

function filterGamesByCategory(
  categories,
  selectedCategory,
  accessCountry,
  isLoggedIn
) {
  const category =
    categories?.find((m) => m?.slug === selectedCategory?.slug)?.games ?? []

  const geoFilteredGamesCategory = filterGeoBlockedItems(
    category,
    accessCountry,
    isLoggedIn
  )

  const providers = new Set()
  geoFilteredGamesCategory?.forEach((game) => providers.add(game?.providerSlug))

  return { providers, games: geoFilteredGamesCategory }
}

function filterProviders(providers, accessCountry, isLoggedIn) {
  return (
    providers?.filter(
      (provider) =>
        provider?.active &&
        !shouldExcludeByGeoLocation(
          provider?.exclude_by_geo_location,
          accessCountry,
          isLoggedIn
        )
    ) || []
  )
}

function filterHomeGames(layout, accessCountry, isLoggedIn) {
  layout?.forEach((layout) => {
    if (layout?.acf_fc_layout === 'games_area') {
      layout.list_of_games[0].games = filterGeoBlockedItems(
        layout.list_of_games[0].games,
        accessCountry,
        isLoggedIn
      )
    }
  })
  return layout
}

function filterPromoGames(layout, accessCountry, isLoggedIn) {
  layout?.forEach((layout) => {
    if (layout?.acf_fc_layout === 'game_category') {
      layout.game_category[0].carousel_games = filterGeoBlockedItems(
        layout.game_category[0].carousel_games,
        accessCountry,
        isLoggedIn
      )
    } else if (layout?.acf_fc_layout === 'games') {
      layout.games = filterGeoBlockedItems(
        layout?.games,
        accessCountry,
        isLoggedIn
      )
    }
  })
  return layout
}

export default {
  filterCasinoData,
  filterPromoGames,
  filterCasinoGamesProviders,
  filterHomeGames,
  filterSearchModalGames,
  filterHorizontalMenu,
  filterCategories,
  filterGamesByCategory,
  filterProviders,
}
